//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations } from 'vuex'
import rules from '../../plugins/rules'

export default {
  props: {
    inactivatedUserInfo: Object,
  },

  data() {
    return {
      rules,
      activateCode: '',
    }
  },

  methods: {
    ...mapMutations('user', ['updateUserInfo']),
    ...mapActions('user', ['activateAccount']),

    activate() {
      const result = this.$refs.activateCode.validate()
      if (!result.then) return
      result.then((valid) => {
        if (!valid) return
        Object.assign(this.inactivatedUserInfo, { activated: true })
        this.updateUserInfo(this.inactivatedUserInfo)
        this.$router.replace('/collection')
      })
    },

    activateCodeRule() {
      return new Promise((resolve) => {
        this.activateAccount({
          activationCode: this.activateCode,
          token: this.inactivatedUserInfo.token,
          callback: () => {
            resolve(true)
          },
          errorCallback: (res) => {
            if (res.data.code == 400) resolve('邀请码不正确')
            else {
              console.log(res)
              this.$q.notify(`未能激活您的账号，错误代码${res.data.code}，请尝试联系客服解决`)
            }
          },
        })
      })
    },

    resetValidation() {
      this.$refs.activateCode.resetValidation()
    },
  },
}
